import { GlobalSettings } from "../global_settings.js";

export const log = ( ...args: any[] ) =>
{
  if ( !GlobalSettings.IS_PROD ) console.log( ...args );
};

export const warn = ( ...args: any[] ) =>
{
  if ( !GlobalSettings.IS_PROD ) console.warn( ...args );
};

export const error = ( ...args: any[] ) =>
{
  if ( !GlobalSettings.IS_PROD ) console.error( ...args );
};

export const group = ( name: string ) =>
{
  if ( !GlobalSettings.IS_PROD ) console.group( name );
};

export const groupEnd = () =>
{
  if ( !GlobalSettings.IS_PROD ) console.groupEnd();
};
